import {FormInputOptionPropsStringString} from "../components/call-taking-form/FormInputProps.tsx";

export const toCamelCaseValidHtmlId = (str: string): string => {
    const camelCaseStr = str.replace(/\s(.)/g, function ($1) {
        return $1.toUpperCase();
    })
        .replace(/\s/g, '')
        .replace(/^(.)/, function ($1) {
            return $1.toLowerCase();
        });

    // Replace invalid id characters with "_"
    let validId = camelCaseStr.replace(/[^a-zA-Z0-9-_:]/g, "_");

    // If the first character is not a letter, prepend an "id" prefix
    if (!validId.match(/^[a-zA-Z]/)) {
        validId = 'id' + validId;
    }

    return validId;
}

export const genDataObj = (labels: string[]): FormInputOptionPropsStringString[] => {
    return labels.map((label) => {
        return {
            label: label,
            value: toCamelCaseValidHtmlId(label)
        };
    });
};

export function waitAtleastXMilliseconds(waitTime: number = 500): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, waitTime);
    });
}

export const getHiddenEmployeeIds = (): Set<string> => {
    // Type-safe access to environment variables
    const hiddenIdsString: string =
        (import.meta.env.VITE_HIDDEN_EMPLOYEE_IDS as string | undefined) || '';

    // Split, trim whitespace, filter out empty strings, and create a Set for fast lookups
    const hiddenIdsSet: Set<string> = new Set(
        hiddenIdsString
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '') // Ensure no empty strings are included
    );

    // Log the hidden IDs for debugging purposes
    if (hiddenIdsSet.size > 0) {
        console.log("Attempting to hide employee IDs:", Array.from(hiddenIdsSet));
    } else {
        console.log("No employee IDs specified for hiding in VITE_HIDDEN_EMPLOYEE_IDS.");
    }

    return hiddenIdsSet;
};

export function isValidEmail(email: string) {
    // Define a regular expression pattern for email validation.
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
}

// export function printPrettyDateTime(currentDate: Date | null): string {
//     if (!currentDate){
//         return ""
//     }
//     currentDate = new Date(currentDate)
//
//     const optionsDate: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'CST' };
//     const optionsTime: Intl.DateTimeFormatOptions = { timeStyle: 'short', timeZone: 'CST' };
//
//     const formatterDate = new Intl.DateTimeFormat('en-US', optionsDate);
//     const formatterTime = new Intl.DateTimeFormat('en-US', optionsTime);
//
//     const formattedDate = formatterDate.format(currentDate);
//     const formattedTime = formatterTime.format(currentDate);
//
//     return `${formattedTime} ${formattedDate}`
//
// }